import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { ApiError } from '@commutifi-fe/interfaces';
import { HttpStatusCode } from '@commutifi-fe/constants';
import { getUrlSubdomain } from 'utils/domains';
import { fetchSubdomainData } from './api';
type SubdomainQueryParams = Parameters<typeof fetchSubdomainData>[1];

// Tenant branding and enterprise identity — fixed for the session, and read on nearly every screen,
// so an inactive copy is worth keeping around rather than refetching after a short gap. Named
// because the bare arithmetic is what let this sit at `24 * 60 * 60` — 86 seconds, not a day.
const SUBDOMAIN_GC_TIME_MS = 24 * 60 * 60 * 1000;
export const subdomainQueryKeys = {
  all: ['subdomains'] as const,
  one: (subdomain: string, queryParams?: SubdomainQueryParams) => [...subdomainQueryKeys.all, subdomain, ...(queryParams ? [queryParams] : [])] as const
};
export const useSubdomain = t0 => {
  const $ = _c(13);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const queryParams = t1;
  let subdomain;
  let t2;
  let t3;
  if ($[2] !== queryParams) {
    subdomain = getUrlSubdomain() ?? "";
    t3 = useQuery;
    t2 = subdomainQueryKeys.one(subdomain, queryParams);
    $[2] = queryParams;
    $[3] = subdomain;
    $[4] = t2;
    $[5] = t3;
  } else {
    subdomain = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  let t4;
  if ($[6] !== queryParams || $[7] !== subdomain) {
    t4 = async t5 => {
      const {
        queryKey: key
      } = t5;
      let response;
      ;
      try {
        response = await fetchSubdomainData(subdomain, queryParams);
      } catch (t6) {
        const error = t6;
        if (ApiError.isApiError(error) && error.status === HttpStatusCode.Unauthorized) {
          return null;
        }
        throw error;
      }
      const {
        data
      } = response;
      return {
        queryKey: key,
        subdomain,
        enterprise: data.enterprise,
        customBranding: data.customBranding
      };
    };
    $[6] = queryParams;
    $[7] = subdomain;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = Boolean(subdomain);
  let t6;
  if ($[9] !== t2 || $[10] !== t4 || $[11] !== t5) {
    t6 = {
      queryKey: t2,
      queryFn: t4,
      enabled: t5,
      gcTime: SUBDOMAIN_GC_TIME_MS
    };
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t3(t6);
};